import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AuthService} from './services/auth.service';
import {ThemeService} from './services/theme.service';
import {MsalService} from '@azure/msal-angular';
import {environment} from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'SJP.TI.AmigoWeb.Hope';
    showHeader: boolean = true;
    private tokenRenewalInterval?: number;

    constructor(
        private authService: AuthService,
        private msalService: MsalService,
        private themeService: ThemeService
    ) {}

    ngOnInit(): void {
        setTimeout(() => {
            if (this.authService.loggedIn) {
                this.startTokenRenewal();
            }
        }, 2000);
    }

    private startTokenRenewal(): void {
        if (this.tokenRenewalInterval) {
            return;
        }
        const renewalInterval = 55 * 60 * 1000;
        
        this.tokenRenewalInterval = window.setInterval(() => {
            this.renewTokens();
        }, renewalInterval);
    }

    private renewTokens(): void {
        const account = this.msalService.instance.getActiveAccount();
        if (!account) {
            console.warn('No active account for token renewal');
            return;
        }
        const allScopes = [
            environment.messagesScopes,
            environment.contactScopes,
            environment.trainOrderScopes,
            environment.alcolockScopes,
            'user.read'
        ];
        allScopes.forEach(scope => {
            this.msalService.acquireTokenSilent({
                account,
                scopes: [scope],
                forceRefresh: true
            }).subscribe({
                next: () => {
                },
                error: (error) => {
                    console.error(`Token refresh failed for ${scope}:`, error?.message || error);
                    if (error?.name === 'InteractionRequiredAuthError') {
                        console.error('Interaction required - redirecting to login');
                        this.msalService.loginRedirect({ scopes: [scope] });
                    }
                }
            });
        });
    }

    ngOnDestroy(): void {
        if (this.tokenRenewalInterval) {
            window.clearInterval(this.tokenRenewalInterval);
        }
    }
}
